import { queryOptions } from '@tanstack/react-query';
import { useApiClient } from 'bff';

export const getIntermediaryToDoList = () => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['intermediaryToDoList'],
    queryFn: async () => reportingApi.reportingGetIntermediaryToDoList(),
    select: (response) => response.data?.clients
  });
};
